import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const AllotAfso_data = async (params) => {

  const response = await fetch(`${process.env.REACT_APP_URL_SALE}/Sales/getScheme_Sale`, {

    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const Scheme_Sale_FPS = ({ month, year, allot_month, allot_year, comm_id, dist_code, afso_code, heading }) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [renderContenttt, setRenderContenttt] = useState(null);
  const [dataTime, setDataTime] = useState("");
  const detailsRRRef = useRef(null); // Use ref to scroll to this div
  const [totals, setTotals] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');

  const calculateTotals = (data) => {
    const columnCount = data[0].c_lst.length * 4; // 4 columns per scheme
    const totals = new Array(columnCount).fill(0); // Initialize totals array with zeros
    const counts = new Array(columnCount).fill(0); // Initialize counts array for averages

    data.forEach((item) => {
      item.c_lst.forEach((colItem, colIndex) => {
        const baseIndex = colIndex * 4; // Each scheme has 4 columns

        totals[baseIndex] += parseInt(colItem.total_cards) || 0;
        totals[baseIndex + 1] += parseInt(colItem.avail_cards) || 0;
        totals[baseIndex + 2] += parseFloat(colItem.avail_qty) || 0;

        const totalValue = parseFloat(colItem.total_cards);
        const cardsValue = parseFloat(colItem.avail_cards);
        if (totalValue > 0 && cardsValue > 0) {
          const availedPerValue = (cardsValue * 100) / totalValue;
          totals[baseIndex + 3] += availedPerValue;
          counts[baseIndex + 3] += 1;
        }

      });
    });

    counts.forEach((count, index) => {
      if (count > 0) {
        totals[index] = index % 4 === 3 ? totals[index] / count : totals[index]; // Only average availed_per
      }
    });

    setTotals(totals);
  };


  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await AllotAfso_data({ month, year, allot_month, allot_year, comm_id, dist_code, afso_code });

        setTabHeading(response_data.heading);
        if (response_data.data && response_data.data.length > 0) {

          setReportData(response_data.data);
          let dTime = response_data.data[0].data_time || "";
          if (dTime) {
            try {
              const date = new Date(dTime);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              let hours = date.getHours();
              const minutes = String(date.getMinutes()).padStart(2, '0');
              const seconds = String(date.getSeconds()).padStart(2, '0');
              const ampm = hours >= 12 ? 'PM' : 'AM';
              hours = hours % 12 || 12;
              const strHours = String(hours).padStart(2, '0');
              dTime = `${day}-${month}-${year} ${strHours}:${minutes}:${seconds} ${ampm}`;
            } catch (e) {
              dTime = dTime.replace('T', ' ').substring(0, 19);
            }
          }
          setDataTime(dTime);
          calculateTotals(response_data.data);

        } else {
          setReportData([]);
        }
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year, allot_month, allot_year, comm_id, dist_code, afso_code]);
  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && detailsRRRef.current) {
      detailsRRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [loading, error, reportData]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0);
  };

  const filteredData = reportData.filter(item => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase().trim();

    if (item.fps_id && item.fps_id.toLowerCase().includes(query)) {
      return true;
    }

    return item.c_lst.some(schemeItem => {
      return (
        (schemeItem.total_cards && schemeItem.total_cards.toString().includes(query)) ||
        (schemeItem.avail_cards && schemeItem.avail_cards.toString().includes(query)) ||
        (schemeItem.avail_qty && schemeItem.avail_qty.toString().includes(query)) ||
        (schemeItem.availed_per && schemeItem.availed_per.toString().includes(query)) ||
        (schemeItem.scheme_short_name && schemeItem.scheme_short_name.toLowerCase().includes(query))
      );
    });
  });


  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  const exportToExcel = async () => {
    if (!reportData || reportData.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Scheme Sale', {
      views: [{ showGridLines: true }]
    });

    const applyStyleToRange = (ws, startRow, startCol, endRow, endCol, styleFn) => {
      for (let r = startRow; r <= endRow; r++) {
        const row = ws.getRow(r);
        for (let c = startCol; c <= endCol; c++) {
          styleFn(row.getCell(c));
        }
      }
    };

    const thinBorder = { style: 'thin', color: { argb: 'FF000000' } };
    const headerFill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFEFEFEF' }
    };

    const totalColumns = 2 + (reportData[0].c_lst.length * 4);

    worksheet.mergeCells(1, 1, 1, totalColumns);
    const titleCell = worksheet.getCell(1, 1);
    titleCell.value = tabHeading || 'Scheme Sale Status';
    titleCell.font = { bold: true, size: 14 };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getRow(1).height = 26;

    const row2 = ["Sl.No", "FPS Id", "Sale Qty in Kgs/Lts"];
    for (let i = 0; i < reportData[0].c_lst.length * 4 - 1; i++) {
      row2.push("");
    }
    worksheet.addRow(row2);

    const row3 = ["", ""];
    reportData[0].c_lst.forEach(scheme => {
      row3.push(scheme.scheme_short_name, "", "", "");
    });
    worksheet.addRow(row3);

    const row4 = ["", ""];
    reportData[0].c_lst.forEach(() => {
      row4.push("Total Cards", "Availed Cards", "Availed Qty (Kgs/Lts)", "Availed %");
    });
    worksheet.addRow(row4);

    worksheet.mergeCells('A2:A4');
    worksheet.mergeCells('B2:B4');
    worksheet.mergeCells(2, 3, 2, totalColumns);

    let currentCol = 3;
    reportData[0].c_lst.forEach(() => {
      worksheet.mergeCells(3, currentCol, 3, currentCol + 3);
      currentCol += 4;
    });

    applyStyleToRange(worksheet, 2, 1, 4, totalColumns, (cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.fill = headerFill;
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });

    worksheet.getRow(2).height = 20;
    worksheet.getRow(3).height = 20;
    worksheet.getRow(4).height = 30;

    let displayData = reportData;
    if (searchQuery) {
      displayData = filteredData;
    }

    displayData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.fps_id || ""
      ];

      row.c_lst.forEach(item => {
        rowData.push(
          Number(item.total_cards || 0),
          Number(item.avail_cards || 0),
          Number(item.avail_qty || 0),
          Number(item.availed_per || 0)
        );
      });

      const r = worksheet.addRow(rowData);

      r.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber === 2) {
          cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
        } else {
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        }
        if (colNumber >= 3) {
          const mod = (colNumber - 3) % 4;
          if (mod === 0 || mod === 1) {
            cell.numFmt = '0';
          } else {
            cell.numFmt = '0.00';
          }
        }
        cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
      });
    });

    const totalRowIndex = worksheet.lastRow.number + 1;
    const totalRowData = ["Total", ""];

    // We maintain totals based on unmodified reportData which UI footer shows
    let currentTotals = totals;

    currentTotals.forEach(total => {
      totalRowData.push(Number(total || 0));
    });

    worksheet.addRow(totalRowData);
    worksheet.mergeCells(totalRowIndex, 1, totalRowIndex, 2);
    applyStyleToRange(worksheet, totalRowIndex, 1, totalRowIndex, totalColumns, (cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
      if (cell._column && cell._column.number >= 3) {
        const mod = (cell._column.number - 3) % 4;
        if (mod === 0 || mod === 1) {
          cell.numFmt = '0';
        } else {
          cell.numFmt = '0.00';
        }
      }
    });

    worksheet.getColumn(1).width = 8;
    worksheet.getColumn(2).width = 22;
    for (let c = 3; c <= totalColumns; c++) {
      worksheet.getColumn(c).width = 15;
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Scheme_Sale_FPS_${month}_${year}.xlsx`);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box></div>
  }
  if (error) {
    return <div className="mainhead" align="center">
      Internal Error
    </div>
  }

  if (reportData.length === 0) {
    return <div className="mainhead" align="center">
      No data found
    </div>
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '90%',
          margin: '0 auto',
          marginBottom: '20px'
        }}
      >
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <PaginationTable
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="Search Fps id."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ padding: '8px', width: '300px' }}
          />
        </div>
      </div>

      <div style={{ overflowX: 'auto', width: '100%', margin: '0 auto' }}>
        <table align="center" width="100%" border={1} id="OfficeReport">
          <thead>
            <tr className="tableheader">
              <th colSpan={2 + ((reportData[0].c_lst.length) * 4)}>{tabHeading}</th>
            </tr>
            <tr className="tableheader">
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>FPS Id</th>
              <th colspan={(reportData[0].c_lst.length) * 4}>Sale Qty in Kgs/Lts</th>
            </tr>
            <tr className="tableheader">
              {reportData[0].c_lst.map((items) => (
                <th colSpan={4} rowSpan={1}>{items.scheme_short_name}</th>
              ))}

            </tr>

            <tr className="tableheader">
              {reportData[0].c_lst.map(() => (
                <>
                  <th rowSpan={1}>Total<br />Cards</th>
                  <th rowSpan={1}>Availed<br />Cards</th>
                  <th rowSpan={1}>Availed<br />Qty<br />(Kgs/Lts)</th>
                  <th rowSpan={1}>Availed<br />%</th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {

              paginatedData.map((item, index) => (
                <tr key={item.fps_id}>
                  <td style={{ textAlign: 'center' }}>{index + 1}</td>
                  <td style={{ textAlign: 'left' }}>  {item.fps_id}  </td>
                  {item.c_lst.map((item1, index) => (
                    <>
                      <td style={{ textAlign: 'right' }} >{item1.total_cards}</td>
                      <td style={{ textAlign: 'right' }} >{item1.avail_cards}</td>
                      <td style={{ textAlign: 'right' }}  >{item1.avail_qty.toFixed(2)}</td>
                      <td style={{ textAlign: 'right' }}  >{item1.availed_per.toFixed(2)}</td>
                    </>
                  ))}
                </tr>
              ))
            }
          </tbody>
          <tfoot>
            <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
              {totals.map((total, index) => (
                <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(2)}</td>
              ))}

            </tr>
            <tr align="center">
              <td colSpan={2 + (reportData[0].c_lst.length * 4)}>
                <button className="button button2" onClick={exportToExcel}>Export to Excel</button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      {dataTime && (
        <div style={{ textAlign: 'right', width: '100%', margin: '10px auto 0', fontWeight: 'bold' }}>
          Last Refresh Time: {dataTime}
        </div>
      )}
      <br /><br />
      <div id='detailsRR' ref={detailsRRRef}>{renderContenttt}</div>
    </>
  );
};

export default Scheme_Sale_FPS;